import "@ncdai/react-wheel-picker/style.css";
import * as WheelPickerPrimitive from "@ncdai/react-wheel-picker";
import { cn } from "../lib/utils";

function WheelPickerWrapper({ children, className, ...props }) {
  return (
    <WheelPickerPrimitive.WheelPickerWrapper
      className={cn(
        // Added 'touch-none' to prevent mobile devices from hijacking the swipe
        "w-56 rounded-lg border border-zinc-200 bg-white px-1 shadow-xs touch-none dark:border-zinc-700/80 dark:bg-zinc-900",
        "*:data-rwp:first:*:data-rwp-highlight-wrapper:rounded-s-md",
        "*:data-rwp:last:*:data-rwp-highlight-wrapper:rounded-e-md",
        className,
      )}
      {...props}
    >
      {children}
    </WheelPickerPrimitive.WheelPickerWrapper>
  );
}

function WheelPicker({
  options,
  classNames,
  dragSensitivity = 0.5,
  scrollSensitivity = 0.5,
  ...props
}) {
  return (
    <WheelPickerPrimitive.WheelPicker
      options={options}
      dragSensitivity={dragSensitivity}
      scrollSensitivity={scrollSensitivity}
      classNames={{
        optionItem: "text-zinc-400 dark:text-zinc-500",
        highlightWrapper: cn(
          "bg-zinc-100 text-zinc-950 dark:bg-zinc-800 dark:text-zinc-50",
          "data-rwp-focused:ring-2 data-rwp-focused:ring-zinc-300 data-rwp-focused:ring-inset dark:data-rwp-focused:ring-zinc-600",
        ),
        ...classNames,
      }}
      {...props}
    />
  );
}

export { WheelPicker, WheelPickerWrapper };
